import { useQuery } from "@tanstack/react-query";
import { FornecedorService } from "../services/fornecedor/fornecedor.service";

const useOrdensCompra = (user, codcli, dataIni, dataFim, paged = true, page = 1, limit = 5, enabled = false, filtros = []) => {
    const query = useQuery({
        queryKey: ["ordens-compra", codcli, dataIni, dataFim, paged, page, limit, filtros],
        queryFn: async () => {
            if (filtros.length > 0) {
                return FornecedorService.filtrarOrdensCompra(
                    user.token,
                    codcli,
                    {
                        filtros: filtros.map((f) => ({
                            campo: f.campo || f.id,
                            valor: f.valor || f.value,
                            uselike: f.uselike ?? true,
                        })),
                    },
                    dataIni,
                    dataFim,
                    paged,
                    page,
                    limit
                );
            }

            const data = await FornecedorService.getOrdensCompra(
                user.token,
                codcli,
                dataIni,
                dataFim,
                paged,
                page,
                limit
            );

            return data;
        },
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 10,
        gcTime: 1000 * 60 * 30,
        enabled: enabled && !!user?.token && !!codcli && !!dataIni && !!dataFim,
    });

    return { ...query };
};

export { useOrdensCompra };
